import { Modal } from "@mantine/core";

import Icon            from "_components/atoms/icon";
import QRCodeComponent from "_components/molecules/QRCode/qrComponent";

import useStyles from "./styles";

const component = ( {
	handleClose,
	open
} ) => {
	const { classes } = useStyles ( { open } );

	return (
		<Modal
			centered
			closeOnEscape            = { true }
			onClose                  = { handleClose }
			opened                   = { open }
			padding                  = { 0 }
			radius                   = "lg"
			size                     = "auto"
			trapFocus                = { true }
			withCloseButton          = { false }
			zIndex                   = { 1500 }
		>
			<Icon
				className = { classes.closeButton }
				name      = "cross"
				onClick   = { handleClose }
			/>

			<QRCodeComponent
				containerClass = { classes.qrCodeContianer }
			/>
		</Modal>
	);
};

export default component;

